// Utilitários do formulário da operação, comuns à parte leve (`credit-note.form-values.ts`) e às regras
// (`credit-note.form.ts`). Não sai do módulo.

export type Values = Record<string, unknown>;

export const isRecord = (value: unknown): value is Values => typeof value === 'object' && value !== null && !Array.isArray(value);
export const str = (value: unknown) => (typeof value === 'string' ? value : '');
export const lower = (value: unknown) => str(value).toLowerCase();
/** O texto de um valor primitivo (`String(x)` do legado); objeto vira ''. */
export const text = (value: unknown): string => (typeof value === 'string' ? value : typeof value === 'number' || typeof value === 'boolean' || typeof value === 'bigint' ? String(value) : '');

